import * as constants from '../constants/CONSTANT';

const QuoteLineItemApi = {
  async fetchByQuote(quoteId) {
    const token = localStorage.getItem('token');
    const response = await fetch(
      `${constants.API_BASE_URL}/api/quotelineitem/${quoteId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );
    return await response.json();
  },
};

export default QuoteLineItemApi;
